import { plainToClass } from '@ftr/serialization';
import { assertUnreachable } from '../../shared/assertUnreachable';
import { JoinAudioSegmentHearingAnnotationsRoomRequest } from './JoinAudioSegmentHearingAnnotationsRoomRequest';
import { JoinAudioSegmentLiveStreamRoomRequest } from './JoinAudioSegmentLiveStreamRoomRequest';
import { JoinAudioSegmentLiveStreamSealedContentRoomRequest } from './JoinAudioSegmentLiveStreamSealedContentRoomRequest';
import { JoinGeneralRoomRequest } from './JoinGeneralRoomRequest';
import { JoinRecordingHearingAnnotationsRoomRequest } from './JoinRecordingHearingAnnotationsRoomRequest';
import { JoinRecordingLiveStreamRoomRequest } from './JoinRecordingLiveStreamRoomRequest';
import { JoinRecordingLiveStreamSealedContentRoomRequest } from './JoinRecordingLiveStreamSealedContentRoomRequest';
import { getHearingAnnotationsRoom, getLiveStreamRoom, getLiveStreamSealedContentRoom } from './JoinRoomUtils';
export function toJoinRoomRequest(object) {
    if (object === undefined || object === null)
        throw new Error('object is required');
    if (typeof object !== 'object')
        throw new Error('object must be an object');
    const asJoinReq = object;
    if ('roomId' in asJoinReq) {
        return plainToClass(JoinGeneralRoomRequest, asJoinReq);
    }
    switch (asJoinReq.type) {
        case 'recording-live-stream':
            return plainToClass(JoinRecordingLiveStreamRoomRequest, asJoinReq);
        case 'recording-live-stream-sealed-content':
            return plainToClass(JoinRecordingLiveStreamSealedContentRoomRequest, asJoinReq);
        case 'audio-segment-live-stream':
            return plainToClass(JoinAudioSegmentLiveStreamRoomRequest, asJoinReq);
        case 'audio-segment-live-stream-sealed-content':
            return plainToClass(JoinAudioSegmentLiveStreamSealedContentRoomRequest, asJoinReq);
        case 'recording-hearing-annotations':
            return plainToClass(JoinRecordingHearingAnnotationsRoomRequest, asJoinReq);
        case 'audio-segment-hearing-annotations':
            return plainToClass(JoinAudioSegmentHearingAnnotationsRoomRequest, asJoinReq);
        default:
            assertUnreachable(asJoinReq);
    }
}
export function getRoomId(joinRoomRequest) {
    if ('roomId' in joinRoomRequest) {
        return joinRoomRequest.roomId;
    }
    switch (joinRoomRequest.type) {
        case 'audio-segment-live-stream':
        case 'recording-live-stream':
            return getLiveStreamRoom(joinRoomRequest.recordingId);
        case 'audio-segment-live-stream-sealed-content':
        case 'recording-live-stream-sealed-content':
            return getLiveStreamSealedContentRoom(joinRoomRequest.recordingId);
        case 'recording-hearing-annotations':
        case 'audio-segment-hearing-annotations':
            return getHearingAnnotationsRoom(joinRoomRequest.recordingId);
        default:
            assertUnreachable(joinRoomRequest);
    }
}
